import React from 'react';

import { l10n } from '@ott/l10n';
import { modalIcons } from '@ott/modal';

import { ReleaseErrors } from './constants';

export const getErrorModalContent = (error: string) => {
  switch (error) {
    case ReleaseErrors.phoneUsed:
      return {
        title: l10n('virtualCard.errors.releaseError.title'),
        description: l10n('virtualCard.errors.phoneUsed.description'),
        actionButtonText: l10n('virtualCard.errors.serverError.action'),
      };
    case ReleaseErrors.taxNotOk:
      return {
        title: l10n('virtualCard.errors.taxNotOkRelease.title'),
        description: l10n('virtualCard.errors.taxNotOkRelease.description'),
        actionButtonText: l10n('virtualCard.errors.taxNotOk.action'),
        icon: <modalIcons.ModalWarningIcon />,
      };

    default:
      return {
        title: l10n('virtualCard.errors.releaseError.title'),
        description: l10n('virtualCard.errors.releaseError.description'),
        actionButtonText: l10n('virtualCard.errors.releaseError.action'),
      };
  }
};
